import DataPenunjang from "@/services/DataPenunjang";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import _, { has } from "lodash";
import { appModule } from "./app";
import DataResepFarmasi from "@/services/DataResepFarmasi";

interface ListResepFarmasi {
  no_transaksi: string;
  tgl: string;
  unit: object;
  item: Array<object>;
}

interface DetailResepFarmasi {
  // no_transaksi: string;
  // tgl: string;
  // kd_upm: string;
  // unit: string;
  // kd_obat: string;
  // nama: string;
  // qty: string;
  // satuan: string;
  // aturan: string;
  no_transaksi: string;
  tgl: string;
  unit: object;
  item: Array<object>;
}

@Module({ store, dynamic: true, name: "storeResepFarmasi" })
class ResepFarmasiStore extends VuexModule {
  listResepFarmasi: ListResepFarmasi[] = [];
  detailResepFarmasi = {} as DetailResepFarmasi;

  @Mutation SET_LIST_RESEP_FARMASI(listResepFarmasi: ListResepFarmasi[]) {
    this.listResepFarmasi = listResepFarmasi;
  }

  @Mutation SET_DETAIL_RESEP_FARMASI(detailResepFarmasi: DetailResepFarmasi) {
    this.detailResepFarmasi = detailResepFarmasi;
  }

  @Action act_list_resepFarmasi_byReg(reg) {
    appModule.setLoading(true);
    const dt = DataResepFarmasi.getDataListTransaksi(reg);
    dt.then(dt => {
      appModule.setLoading(false);
    const dtList = dt.data;
    this.SET_LIST_RESEP_FARMASI(dtList);
    });
  }

  @Action act_list_resepFarmasi_byTrn(param: any) {
    const no_trans = param["no_transaksi"];
    const tgl = param["tgl"];
    appModule.setLoading(true);
    const dt = DataResepFarmasi.getDataPerTransaksi(no_trans,tgl);
    dt.then(dt => {
      appModule.setLoading(false);
    const dtTrn = dt.data;
   
    this.SET_DETAIL_RESEP_FARMASI(dtTrn);
    });
  }

  @Action clear_list_resepfarmasi() {
    const listResepFarmasi = [];
    this.SET_LIST_RESEP_FARMASI(listResepFarmasi);
  }

  @Action clear_detail_resepfarmasi() {
    // alert("aa")
    const detailresepfarmasi = {
      no_transaksi: "",
      tgl: "",
      unit: {},
      item: []
    };
    this.SET_DETAIL_RESEP_FARMASI(detailresepfarmasi);
  }
}

export const storeResepFarmasi = getModule(ResepFarmasiStore);
